import React from 'react';

export const Page404 = () => {
    return <div>
        <i className="fa-solid fa-planet-ringed"></i>
        <p>404. Страница не найдена!</p>
    </div>
}